import styled from "styled-components";
import { fonts } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";

export const SectionTitle = styled.div`
  font-family: ${fonts.fontBauMedium};
  text-transform: uppercase;
  font-size: 18px;

  ${breakpoints.smDown} {
    font-size: 14px;
  }
`;

export const FlavourItemsWrapper = styled.div`
  margin-right: -80px;
  display: flex;
  flex-flow: row wrap;
  margin-top: 24px;
  margin-bottom: 8px;

  ${breakpoints.mdDown} {
    margin-right: -40px;
  }

  ${breakpoints.smDown} {
    margin-right: 0px;
  }
`;

export const FlavourItem = styled.div`
  width: 89px;
  margin-right: 24px;
  text-align: center;
  margin-bottom: 24px;

  ${breakpoints.smDown} {
    width: 25%;
    margin-bottom: 16px;
    padding-right: 16px;
    margin-right: 0px;
  }
`;

export const FlavourItemImage = styled.img<{ isPlaceholder: boolean }>`
  height: 27px;
  width: ${(props) => (props.isPlaceholder ? "22" : "27")}px;
  margin-bottom: 12px;
`;

export const FlavourItemName = styled.div`
  font-family: ${fonts.fontBauMedium};
  font-size: 11px;
  line-height: 14px;
  text-transform: uppercase;

  ${breakpoints.smDown} {
    font-size: 9px;
    line-height: 12px;
  }
`;
